import { StoreCategoryTitle } from '@client-monorepo/daily-fintech/stores';

export const StoreCategoryToLogoMapper: Record<string, string> = {
  [StoreCategoryTitle.GOLD_AND_COINS]: 'Gem.svg',
  [StoreCategoryTitle.DIGITAL]: 'DigitalDevice.svg',
  [StoreCategoryTitle.FASHION_AND_CLOTHING]: 'Fashion.svg',
  [StoreCategoryTitle.SPORTS_AND_TRAVEL]: 'Entertainment.svg',
  [StoreCategoryTitle.ENTERTAINMENT_AND_TOURISM]: 'Travel.svg',
  [StoreCategoryTitle.MEDICINE_AND_TREATMENT]: 'Pillbox.svg',
  [StoreCategoryTitle.BEAUTY_AND_HEALTH]: 'Beauty.svg',
  [StoreCategoryTitle.TOYS_FOR_CHILDREN_AND_BABIES]: 'GrinningFace.svg',
  [StoreCategoryTitle.HOUSEHOLD_CONSUMER]: 'ShoppingBasket.svg',
  [StoreCategoryTitle.HOME_AND_KITCHEN]: 'HomeAndKitchen.svg',
  [StoreCategoryTitle.BUILDING_TOOLS_AND_INDUSTRIAL_EQUIPMENT]: 'Tools.svg',
  [StoreCategoryTitle.BOOKS_STATIONERY]: 'Book.svg',
  [StoreCategoryTitle.CARS_AND_MOTORCYCLES]: 'Car.svg',
  [StoreCategoryTitle.EDUCATION_AND_ENTERTAINMENT]: 'Graduated.svg',
  [StoreCategoryTitle.SERVICES]: 'Tool.svg',
  [StoreCategoryTitle.RESTAURANT]: 'Restaurant.svg',
  [StoreCategoryTitle.PETS]: 'Bone.svg',
  [StoreCategoryTitle.FLOWER_AND_PLANTS]: 'Leaves.svg',
  [StoreCategoryTitle.BIRTHDAY_GIFTS_AND_ACCESSORIES]: 'Gift.svg',
  [StoreCategoryTitle.SPORT]: 'ball.svg',
  [StoreCategoryTitle.INTERNET_SERVICES]: 'Wireless.svg',
  [StoreCategoryTitle.ONLINE_SHOP]: 'Store.svg',
};
